import { makeAutoObservable } from 'mobx';
import { Product } from 'screens/Paywall/types';
import { stores } from 'state/stores';
import { formatCurrency } from 'translations/formatters';
import { t } from 'translations/t';
import { log } from 'utils/log';

export class UnauthenticatedPaywallViewModel {
  constructor() {
    makeAutoObservable(this);

    log('👷‍♂️ init UnauthenticatedPaywallViewModel');

    this.fetchProductData();
  }

  fetchProductData = async () => {
    await stores.paddlePrices.fetch();
  };

  openedFaqIndex?: number;

  onFAQPress = (index: number) => {
    if (index === this.openedFaqIndex) {
      this.openedFaqIndex = undefined;
    } else {
      this.openedFaqIndex = index;
    }
  };

  selectedProductId: string = 'hevypro_yearly_tier24';

  get selectedProductPrice() {
    return stores.paddlePrices.prices.find(p => p.paddle_price_id === this.selectedProductId)
      ?.price_usd;
  }

  get ctaTitle() {
    return t('web.pricing.unauthenticatedPaywall.getStarted');
  }

  onCtaClick = async () => {
    window.location.href = '/signup';
  };

  get products(): Product[] {
    const { selectedProductId } = this;

    const { monthlyPrice, yearlyPrice, lifetimePrice } = stores.paddlePrices;
    if (!monthlyPrice || !yearlyPrice || !lifetimePrice) return [];
    return [
      {
        key: 'hevypro_1month_tier3',
        title: t('paywall.priceCard.billed.monthly'),
        description: t('paywall.priceCard.description.monthly'),
        price: formatCurrency(monthlyPrice.price_usd),
        isSelected: selectedProductId === 'hevypro_1month_tier3',
        onClick: () => (this.selectedProductId = 'hevypro_1month_tier3'),
      },
      {
        key: 'hevypro_yearly_tier24',
        title: t('paywall.priceCard.billed.yearly'),
        description: t('web.paywall.priceCard.description.yearly'),
        discountedPrice: undefined,
        price: formatCurrency(yearlyPrice.price_usd),
        hint: undefined,
        isSelected: selectedProductId === 'hevypro_yearly_tier24',
        onClick: () => (this.selectedProductId = 'hevypro_yearly_tier24'),
      },
      {
        key: 'hevypro_lifetime_tier55',
        title: t('paywall.priceCard.billed.lifetime'),
        description: t('paywall.priceCard.description.lifetime'),
        price: formatCurrency(lifetimePrice.price_usd),
        isSelected: selectedProductId === 'hevypro_lifetime_tier55',
        onClick: () => (this.selectedProductId = 'hevypro_lifetime_tier55'),
      },
    ];
  }
}
